export const beds = [
    {
        id: 'bed',
        name: 'Bed',
        productionPerHarvest: {
          common: 1,
          uncommon: 2,
          rare: 4,
          epic: 8,
          legendary: 16,
        }
    }
]
